export default "__VITE_ASSET__C9$MLg4e__"